var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('v-btn',{staticClass:"mt-2",attrs:{"title":"Crear un nuevo registro","color":"primary","small":"","depressed":""},on:{"click":_vm.handleClickNew}},[_vm._v(" nuevo ")])],1)],1),_c('InvoiceList',{ref:"InvoiceListRef",attrs:{"clickable":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }